// sendViewTracking.js
'use strict';
import { REMOVE_OPERATION_DATA } from '../ActionTypes.js';
import {
  IMPRESSION_TRACKING_VISIBILITY_RATIO,
  IMPRESSION_TRACKING_DURATION_SECONDS,
} from '../RemoteConfigKeys.js';

import getOperationData from '../selector/getOperationData.js';
import getRemoteConfigData from '../selector/getRemoteConfigData.js';

import trackMixpanel, { EventTypes } from '../resource/mixpanel.js';

/**
 * Send view tracking
 * @kind action
 * @param {object} {data} - tracking data.
 * @param {mixpanel.EventTypes} {data.type} - mixpanel event types.
 * @param {object} {data.payload} - event payload.
 * @return {Promise} Action promise.
 */
const sendViewTracking =
  ({ type, payload = {} } = {}) =>
  async (dispatch, getState) => {
    let trackingPayload;
    switch (type) {
      case EventTypes.VIEW_CLOSED: {
        trackingPayload = {
          ...payload,
          extraProps: {
            ...(payload.extraProps || {}),
            'impression.condition.visibility_ratio': getRemoteConfigData(
              getState(),
              IMPRESSION_TRACKING_VISIBILITY_RATIO
            ),
            'impression.condition.duration': getRemoteConfigData(
              getState(),
              IMPRESSION_TRACKING_DURATION_SECONDS
            ),
            ...(getOperationData(getState(), ['viewportItemTrackingPayload']) ||
              {}),
          },
        };
        dispatch({
          type: REMOVE_OPERATION_DATA,
          payload: {
            selectPath: ['viewportItemTrackingPayload'],
          },
        });
        break;
      }
      default: {
        trackingPayload = { ...payload };
      }
    }
    return trackMixpanel({
      type,
      payload: trackingPayload,
    });
  };

export default sendViewTracking;
